import { useEffect, useState } from "react";
import { FormattedOwnerData } from "../../../../core/models/ownerData/ownerData.model";
import { CifCupsState } from "../../../../core/models/cupsCifSelector/cupsCifSelector.model";

interface UseProcessedOwnerDataProps {
  ownerData: FormattedOwnerData | null;
  cifCupsState: CifCupsState;
  isAgent: boolean | null;
}

const useProcessedOwnerData = ({
  isAgent,
  ownerData,
  cifCupsState,
}: UseProcessedOwnerDataProps) => {
  const [processedOwnerData, setProcessedOwnerData] =
    useState<FormattedOwnerData | null>(null);

  useEffect(() => {
    //add situation property to ownerData for agents
    if (isAgent && ownerData && cifCupsState) {
      const updatedOwnerData = {
        ...ownerData,
        cups: ownerData.cups.map((cup) => {
          const foundCifCup = cifCupsState.listCupsCifRaw.find((cifCup) =>
            cifCup.cups.some((c) => c.cupsCode === cup.codeCups),
          );

          if (foundCifCup) {
            const foundCup = foundCifCup.cups.find(
              (c) => c.cupsCode === cup.codeCups,
            );
            if (foundCup?.situation) {
              return {
                ...cup,
                situation: foundCup.situation,
              };
            }
          }

          return cup;
        }),
      };

      setProcessedOwnerData(updatedOwnerData);
    } else {
      setProcessedOwnerData(ownerData || null);
    }
  }, [isAgent, ownerData, cifCupsState]);

  return { processedOwnerData, setProcessedOwnerData };
};

export default useProcessedOwnerData;
